import { API } from "@/services/api";
import { overviewEndpoints } from "@/constant/endpoints";
import { buildQueryString } from "@/utils/common.utils";
import {
  AttentionParams,
  AttentionResponse,
  OverviewActivityParams,
  OverviewActivityResponse,
  OverviewExportResponse,
  OverviewRangeParams,
  OverviewStats,
} from "@/types/overview.types";

async function get<T>(url: string, params: OverviewRangeParams = {}): Promise<T> {
  const response = await API.Get<T>(`${url}${buildQueryString(params)}`);
  if (response.data) return response.data;
  throw new Error(response.message);
}

export const getOverviewStatsService = (params: OverviewRangeParams = {}) =>
  get<OverviewStats>(overviewEndpoints.stats, params);

export const getRequiresAttentionService = (params: AttentionParams = {}) =>
  get<AttentionResponse>(overviewEndpoints.requiresAttention, params);

export const getOverviewActivityService = (params: OverviewActivityParams = {}) =>
  get<OverviewActivityResponse>(overviewEndpoints.activity, params);

export const getOverviewExportService = (params: OverviewRangeParams = {}) =>
  get<OverviewExportResponse>(overviewEndpoints.export, params);
